export default __webpack_public_path__ + "3c4ef45ab083a69a59b74c4b6e8a5d2b.png";